import { colors, useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    dialogContent: {
      paddingTop: 0,
      paddingBottom: theme.spacing(3),
    },
    form: {
      display: 'flex',
      overflowY: 'auto',
      flexDirection: 'column',
    },
    dialogTitleRoot: {
      paddingTop: theme.spacing(),
      paddingBottom: theme.spacing(),
    },
    dialogTitleContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    hiddenOverflow: {
      overflow: 'hidden',
    },
    sectionDragHandle: {
      marginRight: theme.spacing(2),
      color: colors.grey[600],
    },
  };
};
